import Navbar from "./components/Navbar/Navbar";
import { Route, Routes, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "./App.css";
import {
  useTokenContract,
  useTokenContract1,
  useStakingContract,
  useStakingContract1,
} from "./Hooks";
import Home from "./components/home";
import Statistics from "./components/statistics";
import Summary from "./components/summary";
import { Environment } from "./environment";
import { useWeb3React } from "@web3-react/core";
import NetworkChange from "./NetworkModal";
import Web3 from "web3";
import RouterSwap from "./pages/Bridge/RouterSwap";
import axios from "axios";
import { InjectedConnector } from "@web3-react/injected-connector";
import NetworkModal from "./pages/Bridge/networkModal";

const web3 = new Web3(
  Web3.givenProvider ? Web3.givenProvider : "https://bsc-dataseed.binance.org/"
);

function App() {
  const { account, activate } = useWeb3React();
  const loc = useLocation();
  const injected = new InjectedConnector({
    supportedChainIds: [56, 1],
  });
  const [stakeDetails, setstakeDetails] = useState([]);
  const StakingContract = useStakingContract(account);
  const tokenContract = useTokenContract(account);
  const [staked, setstaked] = useState(0);
  const [unstaked, setunstaked] = useState(0);
  const [withdrwan, setwithdrwan] = useState(0);
  const [reward, setreward] = useState(0);
  const [currentStaked, setcurrentStaked] = useState(0);
  const [earned, setearned] = useState(0);
  const [balance, setbalance] = useState(0);
  const [totalStakers, settotalStakers] = useState(0);
  const [totalstaked, settotalstaked] = useState(0);
  const [Apy, setApy] = useState(0);
  const StakingContract1 = useStakingContract1();
  const tokenContract1 = useTokenContract1();
  const [switchNetwork, setswitchNetwork] = useState(false);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("");
  const [chain56, setChain56] = useState();
  const [chain1, setChain1] = useState();
  const [currentChainId, setCurrentChainId] = useState();

  const startTime = () => {
    setInterval(async () => {
      try {
        const dec = +(await tokenContract.decimals());
        const decimals = +Math.pow(10, dec);
        const reward = await StakingContract.realtimeReward(account);
        setearned((+reward / decimals).toFixed(4));
      } catch (e) {
        console.log(e, "error");
      }
    }, 1000);
  };
  const init1 = async () => {
    try {
      const dec = +(await tokenContract1.methods.decimals().call());
      const decimals = +Math.pow(10, dec);
      const totalStaked =
        +(await tokenContract1.methods
          .balanceOf(Environment.StakingContract)
          .call()) / decimals;
      console.log(totalStaked, "totalStaked");
      const totalstakers = +(await StakingContract1.methods
        .totalStakers()
        .call());
      console.log(totalStakers, "stakers");
      setApy(+totalStaked);
      settotalstaked(totalStaked);
      settotalStakers(totalstakers);
    } catch (e) {
      console.log(e, "error");
    }
  };

  const init = async () => {
    try {
      const dec = +(await tokenContract.decimals());
      const decimals = +Math.pow(10, dec);
      console.log(decimals, "decimals");

      const {
        totalStakedTokenUser,
        totalWithdrawanTokenUser,
        totalUnStakedTokenUser,
        totalClaimedRewardTokenUser,
        stakeCount,
      } = await StakingContract.Stakers(account);
      const balance = +(await tokenContract.balanceOf(account)) / decimals;
      console.log(balance, "balance");
      setbalance(balance);
      setstaked(+totalStakedTokenUser / decimals);
      setwithdrwan(+totalWithdrawanTokenUser / decimals);
      setreward(+totalClaimedRewardTokenUser / decimals);
      const result = +totalWithdrawanTokenUser + +totalUnStakedTokenUser;
      setunstaked(+result / decimals);

      if (+stakeCount > 0) {
        let arr = [];
        let currentstaked = 0;
        for (let i = 0; i < +stakeCount; i++) {
          const { amount, withdrawan, unstaked, withdrawtime } =
            await StakingContract.stakersRecord(account, i.toString());
          const obj = {
            time: +withdrawtime,
            amount: +amount / +decimals,
            withdrawan: withdrawan,
            unstaked: unstaked,
          };
          if (!unstaked && !withdrawan) {
            currentstaked += +amount / +decimals;
          }
          arr.push(obj);
        }
        setcurrentStaked(currentstaked);
        setstakeDetails([...arr]);
      }
    } catch (e) {
      console.log(e, "error");
    }
  };
  useEffect(() => {
    if (loc.pathname === "/bridge") {
      return;
    } else if (loc.pathname === "/") {
      console.log(currentChainId);
      if (currentChainId === 1) {
        setswitchNetwork(true);
      } else {
        if (StakingContract && account && tokenContract) {
          init();
          startTime();
        }
        if (StakingContract1 && tokenContract1) {
          init1();
        }
      }
    }
  }, [StakingContract, tokenContract, account, loc]);

  let chain = async () => {
    const chainid = await web3.eth.getChainId();
    setCurrentChainId(chainid);
  };
  const chainRecord = async () => {
    axios
      .get(
        `https://bridgeapi.anyswap.exchange/v3/serverinfoV3?chainId=56&version=UNDERLYINGV2`
      )
      .then(function (response) {
        let data = Object.entries(response.data);
        data.map((data, i) => {
          if (data[0] === "0x887d9c01fff04022da9c6d64a65a481a9e5d1fca") {
            setChain56(data[1].destChains[1]);
          }
        });
      })
      .catch(function (error) {
        console.log(error);
      });

    axios
      .get(
        `https://bridgeapi.anyswap.exchange/v3/serverinfoV3?chainId=1&version=UNDERLYINGV2`
      )
      .then(function (response) {
        let data = Object.entries(response.data);
        data.map((data, i) => {
          if (data[0] === "0xc741f06082aa47f93729070ad0dd95e223bda091") {
            setChain1(data[1].destChains[56]);
          }
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    const storage = localStorage.getItem("wallet");
    if (storage === "meta") {
      activate(injected);
    }
    chain();
    chainRecord();
  }, []);

  return (
    <>
      <NetworkChange open={switchNetwork} setOpen={setswitchNetwork} />
      <NetworkModal
        setSelected={setSelected}
        open={open}
        setOpen={setOpen}
        setCurrentChainId={setCurrentChainId}
      />
      <>
        <Navbar
          setswitchNetwork={setswitchNetwork}
          setCurrentChainId={setCurrentChainId}
        />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Home
                  init={init}
                  init1={init1}
                  balance={balance}
                  currentStaked={currentStaked}
                  totalStakers={totalStakers}
                  totalstaked={totalstaked}
                  Apy={Apy}
                  account={account}
                  reward={reward}
                />
                <Summary
                  staked={staked}
                  unstaked={unstaked}
                  withdrwan={withdrwan}
                  reward={reward}
                  currentStaked={currentStaked}
                  earned={earned}
                  balance={balance}
                />
                <Statistics
                  init={init}
                  init1={init1}
                  stakeDetails={stakeDetails}
                />
              </>
            }
          />
          <Route
            path="/bridge"
            element={
              <RouterSwap
                setOpen={setOpen}
                selected={selected}
                chain56={chain56}
                chain1={chain1}
                currentChainId={currentChainId}
              />
            }
          />
        </Routes>
      </>
    </>
  );
}

export default App;
